import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import util from '@/util/util'

Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/kfsmzj',
      name: 'Kfsmzj',
      component: resolve => require(['@/components/kfsmzj.vue'], resolve)
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/components/login.vue'], resolve)
    },
    {
      path: '/warning_detail/:deviceType/:deviceId/:cid/:createTime',
      name: 'warning_detail',
      component: resolve => require(['@/components/warning_detail.vue'], resolve)
    },


    {
      path: '/smok_detail/:deviceType/:deviceId/:cid',
      name: 'smok_detail',
      component: resolve => require(['@/components/smok_detail.vue'], resolve)
    },
    {
      path: '/combWaring_detail/:deviceType/:deviceId/:cid',
      name: 'combWaring_detail',
      component: resolve => require(['@/components/combWaring_detail.vue'], resolve)
    },
    {
      path: '*',
      name: 'notfound',
      component: resolve => require(['@/components/NotFound.vue'], resolve)
    },
    {
      path: '/',
      component: resolve => require(['@/views/home/index.vue'], resolve),
      children: [
        {
          path: '',
          redirect: 'now'
        },
        {
          path: 'personal',
          component: resolve => require(['@/components/Person.vue'], resolve)
        },
        {
          path: 'now',
          meta: {
            key: 'realtime'
          },
          component: resolve => require(['@/components/Now.vue'], resolve),
          children: [
            {
              path: '',
              redirect: 'area'
            },
            {
              path: 'area',
              name: 'area',
              component: resolve => require(['@/views/area/index'], resolve),
            },
            {
              path: 'fire/:deviceType/:deviceId/:cid',
              name: 'fire_detail',
              component: resolve => require(['@/views/device/fire'], resolve)
            },
            {
              path: 'history/:deviceType/:deviceId/:cid',
              name: 'fire_history',
              component: resolve => require(['@/views/history/fire'], resolve)
            },
            {
              path: 'history/:deviceType/:deviceId/:cid',
              name: 'cb_history',
              component: resolve => require(['@/views/history/cb'], resolve)
            },
            {
              path: 'alarm/:deviceType/:deviceId/:cid',
              name: 'alarm',
              component: resolve => require(['@/views/alarm/index'], resolve)
            },
            {
              path: 'alarm/:deviceType/:deviceId/:cid',
              name: 'fire_alarm',
              component: resolve => require(['@/views/alarm/fire'], resolve)
            },
            {
              path: 'weekly/:deviceType/:deviceId/:cid',
              name: 'weekly',
              meta: {
                title: '周报统计'
              },
              component: resolve => require(['@/views/weekly/index'], resolve)
            },
            {
              path: 'cb/:deviceType/:deviceId/:cid',
              name: 'cb_detail',
              component: resolve => require(['@/views/device/cb'], resolve)
            },
            {
              path: 'zonghe/:cid',
              name: 'zonghe',
              component: resolve => require(['@/components/now/zonghe'], resolve),
              meta:{
                keepAlive:false
              }
            },







            {
              path: 'kfsmzj',
              name: 'kfsmzj',
              component: resolve => require(['@/components/now/Kfsmzj'], resolve),
            },

            {
              path: 'arcm/:deviceType/:deviceId/:cid',
              name: 'arcm_detail',
              component: resolve => require(['@/components/now/ArcmDetail/detail'], resolve)
            },
            {
              path: 'device/:cid',
              name: 'device',
              component: resolve => require(['@/components/now/Device'], resolve),
              // meta:{
              //   keepAlive:true
              // }
            },

            {
              path: 'param/:deviceType/:deviceId',
              name: 'param',
              component: resolve => require(['@/components/now/Param'], resolve),
            },
            {
              path: 'image/:id',
              name: 'image',
              component: resolve => require(['@/components/now/Image'], resolve),
            },


            {
              path: 'comb/:deviceType/:deviceId/:cid',
              name: 'comb_detail',
              component: resolve => require(['@/components/now/CombDetail'], resolve)
            },
            {
              path: 'historical',
              name: 'air_historical',
              component: resolve => require(['@/components/now/AirDetail/historicalData'], resolve)
            },






            {
              path: 'healthy',
              name: 'healthy',
              meta: {
                title: '设备健康分析'
              },
              component: resolve => require(['@/components/now/Stats/healthy'], resolve)
            },

            {
              path: 'warning/:deviceType/:deviceId/:cid',
              name: 'warning',
              component: resolve => require(['@/components/warning/table'], resolve)
            },
            {
              path: 'warning_index/:deviceType/:deviceId/:cid',
              name: 'warning_index',
              component: resolve => require(['@/components/warning/warningIndex'], resolve)
            },
            {
              path: 'smok_table/:deviceType/:deviceId/:cid',
              name: 'smok_table',
              component: resolve => require(['@/components/warning/smokTable'], resolve)
            },
            {
              path: 'comb_table/:deviceType/:deviceId/:cid',
              name: 'comb_table',
              component: resolve => require(['@/components/warning/combTable'], resolve)
            },
          ]
        },

        {
          path: 'warning_detail',
          name: 'warning_detail',
          component: resolve => require(['@/components/warning/warningDetail'], resolve)
        },
        {
          path: 'healthy_radar/:deviceType/:deviceId/:cid',
          name: 'healthy_radar',
          meta: {
            title: '设备健康分析图'
          },
          component: resolve => require(['@/components/now/Stats/healthyRadar'], resolve)
        },

        {
          path: 'now-warning',
          component: resolve => require(['@/components/now-warning.vue'], resolve),
          children: [
            {
              path: '',
              redirect: 'table'
            },
            {
              path: 'table',
              name: 'now-warning-table',
              component: resolve => require(['@/components/now-warning/table'], resolve)
            }
          ]
        },
        {
          path: 'warning',
          component: resolve => require(['@/components/Warning.vue'], resolve),
          children: [
            {
              path: '',
              redirect: 'table',
            },
            {
              path: 'table',
              component: resolve => require(['@/components/warning/table'], resolve)
            },
            {
              path: 'list',
              component: resolve => require(['@/components/warning/list'], resolve)
            }
          ]
        },

        {
          path: 'port/:id/:cid',
          name: 'port',
          component: resolve => require(['@/components/now/Stats/port'], resolve),
        }
      ]
    }
  ]
})


router.beforeEach((to, from, next) => {
  NProgress.done().start()
  let toName = to.name;
  let toPath = to.path;
  let fromName = from.name;
  let loginState = util.getCookie('auth')

  console.log("toName")
  console.log(toName)
  if ((loginState == 'undefined' || loginState == '') && toName !== 'Login' && toName !== 'Kfsmzj') {
    console.log('to_login')
    next({
      path: '/login'
    })

  } else {
    console.log('to_nologin')
    var is_login;
    try {
      is_login = util.getCookie('auth')
    } catch (e) {
      is_login = false
    }

    if (!is_login && toName !== 'Login' && toName !== 'Kfsmzj') {
      next('/login')
    } else {
      next()
    }

  }

})

router.afterEach(route => {
  NProgress.done()
})

export default router




// WEBPACK FOOTER //
// ./src/router/index.js